// extracted by mini-css-extract-plugin
export default {"contractTile":"contractTile_contractTile__9FSHq"};